import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { useFeatureFlag } from './use-feature-flag';

export const useEnableLtlNotifications = (): boolean => {
  return useFeatureFlag(FeatureFlagDeclarations.enableLtlNotifications);
};
